import Title from "../components/ui/Title";
import { useDernierAbonnement } from "../lib/hooks/useAbonnements";
import { Skeleton } from "../components/ui/skeleton";
import BlocAbonnement from "../components/abonnement/BlocAbonnement";
import logoAdf from "../assets/img/logo-adf.png";
import logoSna from "../assets/img/logo-sna-transparent.png";
import BlocHistoriqueAbonnements from "../components/abonnement/BlocHistoriqueAbonnements";
import BlocHistoriqueAssurances from "../components/assurances/BlocHistoriqueAssurances";
import BlocFacturesAPayers from "../components/factures/BlocFacturesAPayers";

const AbonnementPage = () => {
  const { data: abo, isError } = useDernierAbonnement();

  return (
    <div className="mx-auto w-full max-w-7xl pb-8">
      <div className="mb-7">
        <Title>Mon abonnement</Title>
        <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-600 md:text-base">
          Retrouvez votre formule, sa période de validité et vos garanties.
        </p>
      </div>

      <BlocFacturesAPayers />

      <section className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-[0_18px_55px_-35px_rgba(15,23,42,0.45)]">
        <div className="flex min-h-20 items-center border-b border-slate-100 bg-[#fbfaf6] px-5 py-4 sm:px-7 lg:px-8">
          <div className="flex min-w-0 items-center gap-5">
            <div className="h-9 w-36 sm:h-11 sm:w-64">
              <img
                className="h-full max-w-full object-contain object-left"
                src={logoAdf}
                alt="L'Abeille de France et l'Apiculteur"
              />
            </div>
            {!!abo && abo.type === "A" && (
              <div className="hidden h-11 border-l border-slate-200 pl-5 sm:block">
                <img
                  className="h-full object-contain"
                  src={logoSna}
                  alt="Syndicat national d'apiculture"
                />
              </div>
            )}
          </div>
        </div>

        {/* LOADING */}
        {abo === undefined && !isError && (
          <div className="grid gap-5 p-5 sm:p-7 lg:grid-cols-[minmax(0,1fr)_19rem] lg:p-8">
            <div className="space-y-4">
              <Skeleton className="h-7 w-28" />
              <Skeleton className="h-10 w-3/4" />
              <Skeleton className="h-24 w-full" />
            </div>
            <Skeleton className="h-48 w-full rounded-2xl" />
          </div>
        )}

        {/* ERROR */}
        {isError && (
          <div className="m-5 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-medium text-red-700 sm:m-7 lg:m-8">
            Une erreur s'est produite à la récupération de votre abonnement.
          </div>
        )}

        {/* DATA */}
        {abo !== undefined && <BlocAbonnement abonnement={abo} />}
      </section>

      <div className="mt-8 grid items-start gap-6 xl:grid-cols-2">
        <div className="min-w-0">
          <BlocHistoriqueAbonnements />
        </div>
        <div className="min-w-0">
          <BlocHistoriqueAssurances />
        </div>
      </div>
    </div>
  );
};

export default AbonnementPage;
